import { RoutingUrls } from 'common/const';
import { BookingPageQueryParam } from '.';
import { IClientTripBrief } from '@bustickus/models-client';

function bookingPageNavigate(
  trip: IClientTripBrief,
  back: IClientTripBrief | null | undefined,
  dCityId: string | null | undefined,
  aCityId: string | null | undefined
) {
  let params = addQueryParam({}, 'trip', trip.id);
  params = addQueryParam(params, 'back', back?.id);
  params = addQueryParam(params, 'departure', dCityId);
  params = addQueryParam(params, 'arrival', aCityId);

  const searchParams = new URLSearchParams(params);
  const address = `${RoutingUrls.Booking}?${searchParams}`;
  window.location.href = address;
}

function addQueryParam(obj: any, query: BookingPageQueryParam, value: string | null | undefined) {
  if (value == null) {
    return { ...obj };
  }

  return {
    ...obj,
    [query]: value,
  };
}

export default bookingPageNavigate;
